import { useId } from '#imports'
import { provideUseId } from '@headlessui/vue'

export function useProvideHeadlessUiId() {
  provideUseId(() => useId())
}
